import { render, staticRenderFns } from "./ikdceditor.vue?vue&type=template&id=91785ee0&scoped=true&"
import script from "./ikdceditor.vue?vue&type=script&lang=js&"
export * from "./ikdceditor.vue?vue&type=script&lang=js&"
import style0 from "./ikdceditor.vue?vue&type=style&index=0&id=91785ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91785ee0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91785ee0')) {
      api.createRecord('91785ee0', component.options)
    } else {
      api.reload('91785ee0', component.options)
    }
    module.hot.accept("./ikdceditor.vue?vue&type=template&id=91785ee0&scoped=true&", function () {
      api.rerender('91785ee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/ikdceditor.vue"
export default component.exports